import React from "react";

import classnames from "classnames";

import makeBem from "Utils/makeBem";

const bem = makeBem("PlanDetails");

type Props = {
  color: string;
};

export default function RangeBar({ color }: Props) {
  return <div className={classnames(bem("RangeBar"), bem("RangeBar", color))} />;
}
